import React from "react";
import clsx from "clsx";
import { selectUnit } from "@formatjs/intl-utils";
import { FormattedRelativeTime, FormattedMessage } from "react-intl";

import useBalancedText from "./utils/useBalancedText";
import Overline from "@app/components/Overline";
import ContainerBleed from "@app/components/ContainerBleed";

import styles from "./Prediction.module.css";

export default React.forwardRef(function Prediction(
  { className, children, deadline, ...rest },
  ref,
) {
  const textRef = React.useRef();

  useBalancedText(textRef);

  return (
    <ContainerBleed
      ref={ref}
      tag="blockquote"
      className={clsx(styles.prediction, className)}
      {...rest}
    >
      <div className={styles.content}>
        <Overline color="primary">
          <FormattedMessage id="prediction" />
        </Overline>
        <div ref={textRef}>{children}</div>
        {deadline && <PredictionDeadline at={deadline} />}
      </div>
    </ContainerBleed>
  );
});

function PredictionDeadline({ at }) {
  const now = Date.now();
  const date = Date.parse(at);

  if (now > date) {
    // TODO
    return "Verificato?";
  }

  const diff = selectUnit(date, now);

  return (
    <footer className={styles.deadline}>
      <div className={styles.remaining}>
        <FormattedMessage
          id="prediction-will-be-verified-at"
          values={{
            at: <FormattedRelativeTime value={diff.value} unit={diff.unit} />,
          }}
        />
      </div>
      {/* <a href="#!todo" className={styles.subscribe}>
        <FormattedMessage id="notify-me-when-time-is-up" />
      </a> */}
    </footer>
  );
}
